import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD5iwaOc-5rfjczM7C0_rFd6VIbMM2Ugpk",
  authDomain: "mala-51.firebaseapp.com",
  projectId: "mala-51",
  storageBucket: "mala-51.firebasestorage.app",
  messagingSenderId: "63304979263",
  appId: "1:63304979263:web:21c600304aa8fbd4e5398a",
  measurementId: "G-56QJFW6DWN",
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
